import script from "./EventHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventHistory.vue?vue&type=script&setup=true&lang=ts"

import "./EventHistory.vue?vue&type=style&index=0&id=90d36092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d36092"]])

export default __exports__